<div class="relative w-full flex flex-col gap-2 lg:gap-4 overflow-hidden" #mainDom>
  <div
    class="relative w-full flex gap-2 lg:gap-4"
    [ngClass]="{ 'flex-row': width > 300, 'flex-col': width <= 300 }"
  >
    <div #boxColorPicker></div>
    @if (width > 300) {
      <div class="relative w-full flex flex-col">
        <div class="relative w-full flex flex-row">
          <button
            class="w-full px-2 py-1 text-[0.625rem] text-slate-900 border border-r-0 rounded-tl"
            [ngClass]="{
              'bg-white dark:bg-white  dark:text-slate-900': selectedColorListTabIndex === 0,
              'bg-slate-300 dark:bg-black dark:text-white': selectedColorListTabIndex !== 0,
            }"
            (click)="selectedColorListTabIndex = 0"
          >
            Base Color
          </button>
          <button
            class="w-full px-2 py-1 text-[0.625rem] text-slate-900 border rounded-tr"
            [ngClass]="{
              'bg-white dark:bg-white  dark:text-slate-900': selectedColorListTabIndex === 1,
              'bg-slate-300 dark:bg-white dark:text-white': selectedColorListTabIndex !== 1,
            }"
            (click)="selectedColorListTabIndex = 1"
          >
            History
          </button>
        </div>

        <mat-tab-group [selectedIndex]="selectedColorListTabIndex">
          <mat-tab>
            <div
              class="relative rounded w-full flex flex-row flex-wrap items-start align-top gap-1.5 md:gap-3 p-1 md:p-2 bg-slate-100 dark:bg-slate-900 ring-1 ring-slate-300 dark:ring-slate-700"
            >
              @for (defaultColor of defaultColors; track defaultColor) {
                <button
                  (click)="onClicColor(defaultColor)"
                  class="flex-none w-8 h-8 rounded ring-1 ring-slate-700"
                  [ngStyle]="{ backgroundColor: defaultColor }"
                ></button>
              }
            </div>
          </mat-tab>
          <mat-tab>
            <div
              class="relative rounded w-full flex flex-row flex-wrap items-start align-top gap-1.5 md:gap-3 p-1 md:p-2 bg-slate-100 dark:bg-slate-900 ring-1 ring-slate-300 dark:ring-slate-700"
            >
              @for (historyColor of historyColors; track historyColor) {
                <button
                  (click)="onClicColor(historyColor)"
                  class="flex-none w-8 h-8 rounded ring-1 ring-slate-700"
                  [ngStyle]="{ backgroundColor: historyColor }"
                ></button>
              }
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    }
  </div>
  <matte-toggle-button (matteChange)="onChangeMattr($event)"></matte-toggle-button>
  @if (width <= 300) {
    <div class="relative w-full flex flex-col">
      <div class="relative w-full flex flex-row">
        <button
          class="w-full px-2 py-1 text-[0.625rem] text-slate-900 border border-r-0 rounded-tl"
          [ngClass]="{
            'bg-white dark:bg-white  dark:text-slate-900': selectedColorListTabIndex === 0,
            'bg-slate-300 dark:bg-black  dark:text-white': selectedColorListTabIndex !== 0,
          }"
          (click)="selectedColorListTabIndex = 0"
        >
          Base Color
        </button>
        <button
          class="w-full px-2 py-1 text-[0.625rem] text-slate-900 border rounded-tr"
          [ngClass]="{
            'bg-white dark:bg-white  dark:text-slate-900': selectedColorListTabIndex === 1,
            'bg-slate-300 dark:bg-black  dark:text-white': selectedColorListTabIndex !== 1,
          }"
          (click)="selectedColorListTabIndex = 1"
        >
          History
        </button>
      </div>

      <mat-tab-group [selectedIndex]="selectedColorListTabIndex">
        <mat-tab>
          <div
            class="relative rounded w-full flex flex-row flex-wrap items-start align-top gap-1.5 md:gap-3 p-1 md:p-2 bg-slate-100 dark:bg-slate-900 ring-1 ring-slate-300 dark:ring-slate-700"
          >
            @for (defaultColor of defaultColors; track defaultColor) {
              <button
                (click)="onClicColor(defaultColor)"
                class="flex-none w-8 h-8 rounded ring-1 ring-slate-700"
                [ngStyle]="{ backgroundColor: defaultColor }"
              ></button>
            }
          </div>
        </mat-tab>
        <mat-tab>
          <div
            class="relative rounded w-full flex flex-row flex-wrap items-start align-top gap-1.5 md:gap-3 p-1 md:p-2 bg-slate-100 dark:bg-slate-900 ring-1 ring-slate-300 dark:ring-slate-700"
          >
            @for (historyColor of historyColors; track historyColor) {
              <button
                (click)="onClicColor(historyColor)"
                class="flex-none w-8 h-8 rounded ring-1 ring-slate-700"
                [ngStyle]="{ backgroundColor: historyColor }"
              ></button>
            }
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  }
</div>
